export default {
  icon_text: 'Fermé',
  buttons: {
    ok: 'Ok',
  },
};
